import axios from "axios"
import { withServerCache } from "utils/serverCache"

const filterByCategoryTitle = async (title: string) => {
    if (!title) return
    return withServerCache(
        `category-title-${title}`,
        async () => {
            const { data } = await axios.post(
                `${process.env.NEXT_PUBLIC_API_URL}events/filter`,
                { age_group: title }
            )
            return data
        },
        2 * 60 * 1000 // 2 minutes TTL
    )
}

export default filterByCategoryTitle

